<template>
  <b-card class="emergency-contacts-slot slot-component h-100" no-body>
    <div class="d-flex align-items-center justify-content-between px-1 pt-1 pb-50">
      <h5 class="mb-0 d-flex align-items-center">
        <feather-icon icon="PhoneIcon" size="16" class="mr-50" />
        {{ $t("grid.slots.info.emergency_contacts") }}
        <span v-if="unitName" class="text-muted font-weight-normal ml-50">
          · {{ unitName }}
        </span>
      </h5>
      <b-badge v-if="hasContacts" variant="light-primary">{{ contactsCount }}</b-badge>
    </div>

    <div class="emergency-contacts-slot__body px-1 pb-1">
      <emergency-contacts v-if="hasContacts" :emergency-contacts="contacts" />

      <div v-else class="text-center text-muted py-3">
        <feather-icon icon="PhoneOffIcon" size="28" class="mb-1" />
        <p class="mb-0">{{ $t("grid.slots.info.no_emergency_contacts") }}</p>
      </div>
    </div>
  </b-card>
</template>

<script>
import { computed } from "@vue/composition-api";
import { BCard, BBadge } from "bootstrap-vue";
import EmergencyContacts from "./InfoSlot/EmergencyContacts.vue";

export default {
  components: {
    BCard,
    BBadge,
    EmergencyContacts,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const contacts = computed(() =>
      Array.isArray(props.data?.contacts) ? props.data.contacts : []
    );
    const hasContacts = computed(() => contacts.value.length > 0);
    const contactsCount = computed(() => contacts.value.length);
    const unitName = computed(() => props.data?.unitName || "");

    return { contacts, hasContacts, contactsCount, unitName };
  },
};
</script>

<style scoped>
.emergency-contacts-slot {
  overflow: hidden;
}

.emergency-contacts-slot__body {
  overflow-y: auto;
  height: 100%;
}
</style>
